<!-- О внесении изменений в Правила благоустройства территории города Перми -->
<!-- (множественное число слова "изменение" в согласии на обработку персональных данных) -->
<template>
    <div v-if="isSent">
        <p><b>Уважаемый(ая) {{ response.data.first_name }} {{ response.data.middle_name }}.</b></p>
        <p>Ваше предложение от {{ formatDate(new Date(response.data.date)) }} зарегистрировано в базе данных портала под
            номером {{ response.data.uid }}.</p>
        <button class="btn blue" type="button" onclick="window.print()">Напечатать</button>
    </div>
    <div v-else class="col-lg-8">
        <form @submit.prevent="submit" action="" method="post" id="ask" name="ask" enctype="multipart/form-data">

            <input type="hidden" name="ph_project_id" :value="id" required>

            <div class="tile">
                <p style="font-size: 15px;">
                    <strong>Публичные слушания</strong>
                    &nbsp;- это форма реализации прав жителей муниципального образования (общественности) на участие в
                    обсуждении проектов муниципальных правовых актов по вопросам местного значения в случаях,
                    определенных законодательством.
                </p>
                <div class="form-group">
                    <div class="input-field">
                        <h2 style="margin-top: 32px; margin-bottom: 16px;font-size: 28px;text-align: center;">
                            ПРЕДЛОЖЕНИЯ И ЗАМЕЧАНИЯ
                            <br>
                            по проекту решения Пермской городской Думы
                            <br>
                            {{ data.name }}
                        </h2>
                    </div>
                    <div v-html="data.description">
                    </div>
                </div>
            </div>

            <div class="tile reproducing-tile" v-for="(item, index) in proposals" :key="index">
                <div v-if="index == 0" class="form-group">
                    <div class="text required">
                        <strong>Шаг 1.</strong>
                        Для отправки предложения по обсуждаемому проекту
                        необходимо обязательно заполнить все поля формы:
                        <br>
                        <br>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="text required col-md-4">
                        <label for="input-30" class="text required">Пункт, подпункт, абзац</label>
                    </div>
                    <div class="input-group col-md-8">
                        <div class="input-field">
                            <textarea class="text-input" title="Пункт, подпункт, абзац" id="paragraph1" type="text"
                                :name="`proposals[${index}][paragraph]`" value="" required></textarea>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="text required col-md-4">
                        <label for="input-30" class="text required">
                            Редакция проекта решения
                        </label>
                    </div>
                    <div class="input-group col-md-8">
                        <div class="input-field">
                            <textarea class="text-input" title="Редакция проекта решения" type="text" id="edition1"
                                :name="`proposals[${index}][edition]`" value="" required></textarea>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="text required col-md-4">
                        <label for="input-30" class="text required">Предлагаемая редакция</label>
                    </div>
                    <div class="input-group col-md-8">
                        <div class="input-field">
                            <textarea class="text-input" title="Предлагаемая редакция" type="text" id="proposal1"
                                :name="`proposals[${index}][proposal]`" value="" required></textarea>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="text required col-md-4">
                        <label for="input-30" class="text required">Обоснование</label>
                    </div>
                    <div class="input-group col-md-8">
                        <div class="input-field">
                            <textarea class="text-input" title="Обоснование" type="text" id="confirmation1"
                                :name="`proposals[${index}][confirmation]`" value="" required></textarea>
                        </div>
                    </div>
                </div>

                <button v-if="proposals.length == index + 1" @click="addProposal" class="btn blue btn-more"
                    type="button">Еще предложение</button>
            </div>

            <div class="tile">
                <div class="form-group row">
                    <div style="padding-left: 17px;"><strong>Шаг 2.</strong> Заполнить ФИО и контактные данные ниже.
                    </div>
                    <div class="text required col-sm-4">
                        <label class="text required" for="name">
                            Фамилия, имя, отчество физического лица или наименование организации
                        </label>
                    </div>
                    <div class="input-group col-sm-8">
                        <div class="input-field">
                            <input id="name" class="text-input" title="Фамилия или наименование организации" type="text"
                                name="last_name" value="" placeholder="Фамилия или наименование организации" required>
                        </div>
                        <div class="input-field">
                            <input id="firstname" class="text-input" title="Имя" type="text" name="first_name" value=""
                                placeholder="Имя">
                        </div>
                        <div class="input-field if-there-is">
                            <input id="secondname" title="Отчество" type="text" name="middle_name" value=""
                                placeholder="Отчество">
                        </div>

                        <div class="checkbox"><input id="snchk" type="checkbox" name="snchk"
                                onclick="if(document.getElementById('snchk').checked) {document.getElementById('secondname').parentElement.style.display='none';} else{document.getElementById('secondname').parentElement.style.display='block';}">
                            <label for="snchk">Отчество отсутствует</label>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="text required col-md-4">
                        <label for="input-35" class="text required">
                            Год рождения физического лица или дата создания организации
                        </label>
                    </div>
                    <div class="input-group col-md-8">
                        <div class="input-field">
                            <input id="birthday" class="text-input" title="Год рождения физического лица или дата создания
                            организации" type="date" name="birthday" value="" required>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="text required col-md-4">
                        <label for="input-37" class="text required">
                            Адрес места жительства физического лица или места нахождения организации, ОГРН
                        </label>
                    </div>
                    <div class="input-group col-md-8">
                        <div class="input-field">
                            <input id="address" class="text-input"
                                title="Адрес места жительства физического лица или места нахождения организации, ОГРН"
                                type="text" name="address" value="" required>
                        </div>
                    </div>
                </div>

                <div class="input-field">
                    <div class="checkbox">
                        <input style="display: block;max-height: 0px;max-width: 0px;" type="checkbox" id="input-432"
                            required v-model="сonsentСhecked">
                        <label for="input-432">
                            <p>Согласие на обработку персональных данных:</p>
                            <p>
                                В соответствии с Федеральным законом от 27 июля 2006 г. № 152-ФЗ «О персональных данных»
                                даю согласие департаменту градостроительства и архитектуры администрации города Перми
                                (614015, г. Пермь, ул. Сибирская, 15), организационному комитету по организации
                                проведения публичных слушаний по обсуждению проекта решения Пермской городской Думы «О
                                внесении изменений в Правила благоустройства территории города Перми, утвержденные
                                решением Пермской городской Думы от 15.12.2020 № 277» (далее – организатор публичных
                                слушаний) на обработку следующих персональных данных, необходимых для участия в
                                публичных слушаниях:
                                <br>
                                фамилия, имя, отчество;
                                <br>
                                номер и серия документа, удостоверяющего личность, сведения о дате его выдачи и выдавшем
                                органе;
                                <br>
                                адрес места жительства (проживания);
                                <br>
                                адрес электронной почты для корреспонденции (в случае предоставления такого адреса);
                                <br>
                                иные сведения, сообщаемые в составе замечаний и предложений, поданных организатору
                                публичных слушаний.
                                <br>
                                Настоящее согласие предоставляется: на сбор, запись, систематизацию, накопление,
                                хранение, уточнение (обновление, изменение), уничтожение персональных данных.
                                <br>
                                Настоящее согласие вступает в силу с момента его подписания и действует в течение срока
                                хранения протокола публичных слушаний, установленного для хранения официальных
                                документов.
                                <br>
                                Согласие может быть отозвано полностью или частично в любое время на основании
                                письменного заявления субъекта персональных данных, направленного организатору публичных
                                слушаний в произвольной форме.
                                <br>
                                При отказе предоставить персональные данные и (или) дать согласие на их обработку
                                внесенные предложения и замечания по проекту решения Пермской городской Думы «О внесении
                                изменений в Правила благоустройства территории города Перми, утвержденные решением
                                Пермской городской Думы от 15.12.2020 № 277», рассмотрению не подлежат (не учитываются в
                                протоколе публичных слушаний и в заключении о результатах публичных слушаний).
                                <br>
                                Мне разъяснены юридические последствия отказа предоставить свои персональные данные и
                                (или) дать согласие на их обработку.
                            </p>
                            <div v-show="сonsentСhecked">{{ new Date().toLocaleDateString() }}г.</div>
                        </label>
                    </div>
                </div>
            </div>

            <div class="tile">
                <div class="form-group">
                    <div class="text">
                        <strong>Шаг 3.</strong>
                        Приложение *
                        <br>
                        <div class="checkbox">
                            <input id="doclp" type="checkbox" name="doclp"
                                onclick="if(document.getElementById('doclp').checked) {document.getElementById('attach-files').style.display='none';} else{document.getElementById('attach-files').style.display='block';}">
                            <label for="doclp">
                                Предоставить подтверждающие документы при личном присутствии на публичных слушаниях
                            </label>
                            <span id="noDocs" style="display: none; color: #fe1000;">
                                <strong>
                                    Подтвердите согласие предоставить документы лично,
                                    либо приложите документы в виде одного файла или нескольких
                                </strong>
                            </span>
                        </div>
                    </div>
                    <div class="form-group" id="attach-files">
                        <div class="form__title-file active" @click="addFile">Приложить подтверждающие документы</div>
                        <div class="form__input-files">
                            <div class="form__input-file" v-for="(item, index) in files" :key="index">
                                <div class="qwer"></div>
                                <input type="text" class="form__input-files-text" disabled :value="item.name">
                                <div class="form__btns">
                                    <input type="file" name="files[]" :id="`file` + index"
                                        @change="(e) => selectFile(e.target.files[0], index)"
                                        class="form__input-file-elem">
                                    <label :for="`file` + index" class="form__label-file btn blue">Выбрать</label>
                                    <div class="btn blue form__btn form__btn-close" @click="() => deleteFile(index)">
                                    </div>
                                    <div class="btn blue form__btn form__btn-add" @click="addFile"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="info2">
                        <p>
                            * Указываются и прикладываются документы (копии), подтверждающие сведения в соответствии с
                            пунктом 1.5 Положения о порядке организации и проведения публичных слушаний по обсуждению
                            проекта правил благоустройства территории города Перми, утвержденного решением Пермской
                            городской Думы от 26 марта 2019 г. № 57.
                        </p>
                    </div>
                </div>
            </div>

            <div class="tile">
                <div class="form-group row">
                    <div style="padding-left: 17px;">
                        <strong>Шаг 4.</strong>
                        При необходимости перед отправкой возможно напечатать предложения нажав «Напечатать»
                    </div>
                </div>
                <button class="btn blue" type="button" onclick="window.print()">Напечатать</button>
                <div style="padding-top: 10px;">При отсутствии необходимости перейти к следующему шагу.</div>
            </div>

            <div class="tile">
                <div>
                    <strong>Шаг 5.</strong>
                    Направить предложения организатору публичных слушаний/общественных обсуждений нажав «Направить»
                </div>

                <div class="form-group">
                    <div class="text required"><label class="text required" for="captcha">Введите код с
                            картинки</label>
                    </div>

                    <span v-show="errors.find(x => x === 'captcha')" id="no456" style=" color: #fd0b01;">
                        <strong>
                            Вы не ввели код.
                        </strong>
                    </span>
                    <span v-show="errors.find(x => x === 'wrong-captcha')" id="no456" style=" color: #fd0b01;">
                        <strong>
                            Неправильный код, попробуйте снова.
                        </strong>
                    </span>

                    <div class="input-field">
                        <input v-model="captcha" id="captcha" class="text-input" type="text" name="captcha[phrase]"
                            required>
                        <img :src="`${captchasURL}/${captchaId}/image`" style="margin: 10px 0;">
                        <input name="captcha[id]" v-model="captchaId" type="hidden" />
                    </div>
                </div>
                <input class="btn blue" type="submit" value="Направить">
            </div>

        </form>
        <div class="info2">Поля, помеченные "<span style="color: #f64146;">*</span>" обязательны для заполнения</div>
    </div>
</template>

<script>
import { getConfig } from '@/auth'
import captchaMixin from '@/mixins/captchaMixin'

export default {
    mixins: [captchaMixin],
    props: ['data'],
    data() {
        return {
            name: '',
            id: null,
            proposals: [{}],
            files: [],
            isSent: false,
            response: {},
            errors: [],
            сonsentСhecked: false
        }
    },
    async created() {
        this.name = this.$route.path;
        this.id = this.$route.params.id;

        this.getCaptcha()
    },
    methods: {
        submit: async function (event) {
            const response = await fetch(getConfig().apiURL + '/public-hearing/ph-appeals', {
                method: 'POST',
                body: new FormData(event.target),
            })

            if (response.status === 201) {
                this.response = await response.json()
                this.isSent = true
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0
                return
            }

            if (response.status === 422) {
                this.response = await response.json()
                this.errors.push('wrong-captcha')
                document.getElementById('captcha').scrollIntoView({ block: 'center' })
                this.getCaptcha()

                return
            }

            console.error('Ошибка HTTP: ' + response.status)
        },
        addFile: function () {
            this.files.push({})
        },
        selectFile: function (file, index) {
            this.files[index] = file
        },
        deleteFile: function (index) {
            this.files.splice(index, 1)
        },
        addProposal: function () {
            this.proposals.push({});
        },

        formatDate: function (date) {
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0');
            var yyyy = date.getFullYear();
            return dd + '.' + mm + '.' + yyyy;
        },
    }
}
</script>

<style>
.btn-more {
    margin-left: auto;
    display: block;
    margin-right: auto;
}

.btn-print {
    margin-left: 10px;
    color: #2d417a;
    background-color: #ffffff;
}

@media print {
    .captcha {
        display: none;
    }

    .btn-more {
        display: none;
    }

    .page-footer {
        display: none;
    }
}
</style>